<template>
  <NavComponent />
  <LoginPage />
  <Footer />
</template>

<script>
// @ is an alias to /src
import LoginPage from "@/pages/LoginPage.vue";
import NavComponent from "@/components/new/Nav.vue";
import Footer from "@/components/new/Footer.vue";

export default {
  name: "LoginView",
  components: {
    LoginPage,
    NavComponent,
    Footer,
  },
};
</script>

<style scoped>
.main {
  min-height: calc(100vh - var(--nav-height, 80px));
  margin-top: var(--nav-height, 80px);
}
</style>
